import { stringAvatar } from 'utils';
import { MeInfo } from 'library/types';
import { CollapseMenu } from 'components';
import { useEffect, useState } from 'react';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import HubIcon from '@mui/icons-material/Hub';
import LanIcon from '@mui/icons-material/Lan';
import { styled } from '@mui/material/styles';
import DvrIcon from '@mui/icons-material/Dvr';
import TocIcon from '@mui/icons-material/Toc';
import TuneIcon from '@mui/icons-material/Tune';
import WorkIcon from '@mui/icons-material/Work';
import TaskIcon from '@mui/icons-material/Task';
import PeopleIcon from '@mui/icons-material/People';
import StairsIcon from '@mui/icons-material/Stairs';
import SourceIcon from '@mui/icons-material/Source';
import { SideBarItem, isSideBarGroup } from './types';
import StorageIcon from '@mui/icons-material/Storage';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import CategoryIcon from '@mui/icons-material/Category';
import TableRowsIcon from '@mui/icons-material/TableRows';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import { Box, List, Toolbar, Avatar, Typography, Stack } from '@mui/material';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export const sideBarItems: SideBarItem[] = [
  {
    name: <FormattedMessage id="sidebar.dashboard" defaultMessage="Genel Bakış" />,
    routeId: 'dashboard',
    icon: <DashboardIcon />,
  },
  {
    name: <FormattedMessage id="sidebar.freshdesk" defaultMessage="Freshdesk" />,
    routeId: 'freshdeskDashboard',
    icon: <SupportAgentIcon />,
  },
  {
    name: <FormattedMessage id="sidebar.effortTracing" defaultMessage="Efor Takibi" />,
    routeId: 'effortTracing',
    icon: <WorkIcon />,
  },
  {
    name: <FormattedMessage id="sidebar.projectTracking" defaultMessage="Proje Takibi" />,
    icon: <AccountTreeIcon />,
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.createBook" defaultMessage="Proje Oluştur" />,
        routeId: 'book',
        icon: <PlaylistAddIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.projectPlanGenerate" defaultMessage="Proje Planı Oluştur" />,
        routeId: 'projectPlanGenerate',
        icon: <TocIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.projectStepManaging" defaultMessage="Adım Yönetimi" />,
        routeId: 'projectStepManaging',
        icon: <StairsIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.projectMonitoring" defaultMessage="İzleme / Sunum" />,
        routeId: 'projectMonitoring',
        icon: <DvrIcon />,
      },
    ],
  },
  {
    name: <FormattedMessage id="sidebar.activityTracking" defaultMessage="Aktivite Takibi" />,
    icon: <TaskIcon />,
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.activityManaging" defaultMessage="Aktivite Raporu" />,
        routeId: 'activityManaging',
        icon: <StairsIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.projectMonitoring" defaultMessage="İzleme / Sunum" />,
        routeId: 'activityMonitoring',
        icon: <DvrIcon />,
      },
    ],
  },
  {
    name: <FormattedMessage id="sidebar.personnelHoliday" defaultMessage="İzin Takibi" />,
    icon: <BeachAccessIcon />,
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.myPersonnelHoliday" defaultMessage="İzin Taleplerim" />,
        routeId: 'personnelHoliday',
        icon: <BeachAccessIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.holidayMonitoring" defaultMessage="İzleme / Sunum" />,
        routeId: 'holidayMonitoring',
        icon: <DvrIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.yearlyHolidayView" defaultMessage="Yıllık Bakış" />,
        routeId: 'holidayYearlyView',
        icon: <CalendarMonthRoundedIcon />,
      },
    ],
  },
  {
    name: <FormattedMessage id="sidebar.salesCrm" defaultMessage="Satış CRM" />,
    icon: <PointOfSaleIcon />,
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.customerSourceTypes" defaultMessage="Müşteri Kaynakları" />,
        routeId: 'customerSourceTypes',
        icon: <SourceIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.salesStageTypes" defaultMessage="Satış Aşamaları" />,
        routeId: 'salesStageTypes',
        icon: <StairsIcon />,
      },
    ],
  },
  {
    name: <FormattedMessage id="sidebar.reports" defaultMessage="Raporlar" />,
    icon: <SummarizeIcon />,
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.generalReport" defaultMessage="Genel Rapor" />,
        routeId: 'generalReport',
        icon: <TableRowsIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.report" defaultMessage="Proje Raporu" />,
        routeId: 'report',
        icon: <AssessmentIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.productReport" defaultMessage="Ürün Raporu" />,
        routeId: 'productReport',
        icon: <AccountTreeIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.freshdeskFeedbackReport" defaultMessage="Anket Raporu" />,
        routeId: 'freshdeskFeedbackReport',
        icon: <RateReviewOutlinedIcon />,
      },
    ],
  },
  {
    name: <FormattedMessage id="sidebar.adaptations" defaultMessage="Uyarlamalar" />,
    icon: <TuneIcon />,
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.projectGroups" defaultMessage="Ürün Grupları" />,
        routeId: 'projectGroups',
        icon: <CategoryIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.projects" defaultMessage="Ürünler" />,
        routeId: 'projects',
        icon: <AccountTreeIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.activityTypes" defaultMessage="Aktivite Türleri" />,
        routeId: 'activityTypes',
        icon: <TaskIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.connectionTypes" defaultMessage="Bağlantı Türleri" />,
        routeId: 'connectionTypes',
        icon: <HubIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.environmentTypes" defaultMessage="Sunucu Tipleri" />,
        routeId: 'environmentTypes',
        icon: <StorageIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.gibTypes" defaultMessage="GİB Yöntemleri" />,
        routeId: 'gibTypes',
        icon: <LanIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.usedBanks" defaultMessage="Bankalar" />,
        routeId: 'usedBanks',
        icon: <AccountBalanceIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.effortContacts" defaultMessage="Efor Muhatapları" />,
        routeId: 'effortContacts',
        icon: <AttachEmailIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.effortStatusContacts" defaultMessage="Statü <=> Muhatap" />,
        routeId: 'effortStatusContacts',
        icon: <ForwardToInboxIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.productProjectPlan" defaultMessage="Ürün - Proje Planı" />,
        routeId: 'productProjectPlan',
        icon: <ListAltIcon />,
      },
    ],
  },
  {
    name: <FormattedMessage id="sidebar.tools" defaultMessage="Araçlar" />,
    icon: <SettingsIcon />,
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.users" defaultMessage="Kullanıcılar" />,
        routeId: 'users',
        icon: <PeopleIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.roles" defaultMessage="Roller" />,
        routeId: 'roles',
        icon: <RoomPreferencesIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.timeline" defaultMessage="Tarihçe" />,
        routeId: 'timeline',
        icon: <TimelineOutlinedIcon />,
      },
      {
        name: <FormattedMessage id="sidebar.effortTimeline" defaultMessage="Efor Tarihçe" />,
        routeId: 'effortTimeline',
        icon: <TimelineOutlinedIcon />,
      },
    ],
  },
];

type SideBarProps = {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
};

const SideBar = ({ mobileOpen = false, onMobileClose }: SideBarProps) => {
  const [profileInfo, setProfileInfo] = useState<MeInfo | null>(null);

  useEffect(() => {
    let active = true;

    const getValues = async () => {
      try {
        const response = await apiService.me();

        if (active && response.isSuccess) {
          setProfileInfo(response.data);
        }
      } catch {
        if (active) setProfileInfo(null);
      }
    };

    getValues();

    return () => {
      active = false;
    };
  }, []);

  const drawerContent = (
    <>
      <Toolbar />

      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
          <List dense>
            {sideBarItems.map((item, index) => (
              <CollapseMenu sideBarItem={item} key={isSideBarGroup(item) ? `sidebar-group-${index}` : item.routeId} />
            ))}
          </List>
        </Stack>
      </Box>

      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}>
        <Avatar
          sizes="small"
          alt={profileInfo?.nameSurname}
          {...stringAvatar(profileInfo?.nameSurname || '- -')}
          sx={{ width: 36, height: 36 }}
        />

        <Box sx={{ mr: 'auto', minWidth: 0 }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }} noWrap>
            {profileInfo?.nameSurname || '- -'}
          </Typography>

          <Typography variant="caption" sx={{ color: 'text.secondary' }} noWrap>
            {profileInfo?.email || '-'}
          </Typography>
        </Box>
      </Stack>
    </>
  );

  return (
    <>
      {/* Mobile temporary drawer */}
      <MuiDrawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          [`& .${drawerClasses.paper}`]: {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: 'background.paper',
          },
        }}>
        {drawerContent}
      </MuiDrawer>

      {/* Desktop permanent drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' },
          [`& .${drawerClasses.paper}`]: {
            backgroundColor: 'background.paper',
          },
        }}>
        {drawerContent}
      </Drawer>
    </>
  );
};

export default SideBar;
